'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$NewRecipeAppPage$() {
}
export { $c_Lmealorama_AppRouter$NewRecipeAppPage$ as $c_Lmealorama_AppRouter$NewRecipeAppPage$ };
$p = $c_Lmealorama_AppRouter$NewRecipeAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$NewRecipeAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$NewRecipeAppPage$() {
}
export { $h_Lmealorama_AppRouter$NewRecipeAppPage$ as $h_Lmealorama_AppRouter$NewRecipeAppPage$ };
$h_Lmealorama_AppRouter$NewRecipeAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 1868909890;
});
$p.m = (function() {
  return "NewRecipeAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "NewRecipeAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$NewRecipeAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$NewRecipeAppPage$, "mealorama.AppRouter$NewRecipeAppPage$", ({
  Ft: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$NewRecipeAppPage$ as $d_Lmealorama_AppRouter$NewRecipeAppPage$ };
var $n_Lmealorama_AppRouter$NewRecipeAppPage$;
function $m_Lmealorama_AppRouter$NewRecipeAppPage$() {
  if ((!$n_Lmealorama_AppRouter$NewRecipeAppPage$)) {
    $n_Lmealorama_AppRouter$NewRecipeAppPage$ = new $c_Lmealorama_AppRouter$NewRecipeAppPage$();
  }
  return $n_Lmealorama_AppRouter$NewRecipeAppPage$;
}
export { $m_Lmealorama_AppRouter$NewRecipeAppPage$ as $m_Lmealorama_AppRouter$NewRecipeAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-New-Recipe-App-Page$.js.map
